import React, { forwardRef } from 'react';

const StatCard = forwardRef(function StatCard({ user, stats }, ref) {
  const eloRating = user?.eloRating || 1000;
  const eloTitle = user?.eloTitle || 'Rookie';
  const nickname = user?.nickname || 'Player';
  const region = user?.region || '';
  const gamesPlayed = stats?.gamesPlayed || 0;
  const wins = stats?.wins || 0;
  const winRate = gamesPlayed > 0 ? Math.round((wins / gamesPlayed) * 100) : 0;
  const longestStreak = stats?.longestStreak || 0;
  const balance = user?.playMoneyBalance || 0;

  const tierColor =
    eloRating >= 2000 ? '#d4af37' :
    eloRating >= 1600 ? '#c0c0c0' :
    eloRating >= 1200 ? '#cd7f32' : '#8b949e';

  return (
    <div ref={ref} style={{
      width: 400, height: 240, borderRadius: 16,
      background: 'linear-gradient(135deg, #0d1117 0%, #161b22 50%, #1c2333 100%)',
      border: `2px solid ${tierColor}`,
      padding: 24, boxSizing: 'border-box',
      fontFamily: "'Georgia', serif", color: '#e2e8f0',
      position: 'relative', overflow: 'hidden'
    }}>
      {/* Background logo watermark */}
      <img src="/BuckEuchreLogo.png" alt="" style={{
        position: 'absolute', right: -30, bottom: -30,
        width: 180, height: 'auto', opacity: 0.08, pointerEvents: 'none'
      }} />

      {/* Header row */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#e2e8f0' }}>{nickname}</div>
          {region && (
            <div style={{ fontSize: 11, color: '#8b949e', marginTop: 2 }}>{region}</div>
          )}
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 9, color: tierColor, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 1, opacity: 0.8 }}>Skill Rating</div>
          <div style={{ fontSize: 26, fontWeight: 700, color: tierColor }}>{eloRating}</div>
          <div style={{ fontSize: 11, fontWeight: 600, color: tierColor, textTransform: 'uppercase' }}>{eloTitle}</div>
        </div>
      </div>

      {/* Stats grid */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
        <StatBox label="Games" value={gamesPlayed} color="#58a6ff" />
        <StatBox label="Wins" value={wins} color="#3fb950" />
        <StatBox label="Win Rate" value={`${winRate}%`} color={winRate >= 50 ? '#3fb950' : '#f59e0b'} />
        <StatBox label="Best Streak" value={longestStreak} color="#f59e0b" />
      </div>

      {/* Footer */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <img src="/bucks-icon.svg" alt="" style={{ width: 14, height: 14 }} />
          <span style={{ color: '#fbbf24', fontSize: 14, fontWeight: 600 }}>{balance.toLocaleString()}</span>
          <span style={{ color: '#8b949e', fontSize: 10 }}>Bucks</span>
        </div>
        <div style={{ fontSize: 10, color: '#484f58' }}>
          euchretable.com
        </div>
      </div>
    </div>
  );
});

function StatBox({ label, value, color }) {
  return (
    <div style={{
      flex: 1, background: 'rgba(255,255,255,0.04)', borderRadius: 8,
      padding: '8px 6px', textAlign: 'center'
    }}>
      <div style={{ fontSize: 18, fontWeight: 700, color }}>{value}</div>
      <div style={{ fontSize: 9, color: '#8b949e', textTransform: 'uppercase', marginTop: 2 }}>{label}</div>
    </div>
  );
}

export default StatCard;
